module.exports = __webpack_public_path__ + "static/logo-phishing-20e308c36624b558f88ac439470e508b.png";